"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _CalendarBodyHeader2 = _interopRequireDefault(require("./CalendarBodyHeader"));
var _CalendarWeek = _interopRequireDefault(require("./CalendarWeek"));
var _CalendarBodyHeader;
const WEEK_DAYS = 7;
const CalendarBody = _ref => {
  let {
    date,
    dateSelected,
    minDate,
    maxDate,
    onSelect
  } = _ref;
  const weeks = _react.default.useMemo(() => {
    if (!(0, _ark.isValidDate)(date)) return [];
    const dateMonth = date.getMonth();
    const weeks = date.getWeeks(false).map(week => Object.assign({}, week, {
      month: dateMonth
    }));
    if (weeks.length === 4) {
      const [firstWeek] = weeks;
      const lastWeekOfPreviousMonth = date.addMonth(-1).getEndOfMonth().getWeek();
      (0, _ark.insertAt)(weeks, 0, {
        week: lastWeekOfPreviousMonth,
        start: firstWeek.start - 7,
        end: firstWeek.end - 7,
        monthOverlap: true,
        month: dateMonth - 1
      });
    }
    if (weeks.length === 5) {
      const [,,,, lastWeek] = weeks;
      const firstWeekOfNextMonth = date.addMonth(1).getStartOfMonth().getWeek();
      const daysInMonth = date.getEndOfMonth().getDate();
      const startDayOfNextWeek = 7 - (daysInMonth - lastWeek.start);
      (0, _ark.insertAt)(weeks, 5, {
        week: firstWeekOfNextMonth,
        start: startDayOfNextWeek,
        end: startDayOfNextWeek + 6,
        monthOverlap: true,
        month: dateMonth + 1
      });
    }

    // Generates a {WEEK_DAYS} length array for each week
    return weeks.map(_ref2 => {
      let {
        week,
        start,
        end,
        monthOverlap,
        month
      } = _ref2;
      return {
        week,
        days: new Array(WEEK_DAYS).fill(null).map((_, idx) => {
          const newDate = date.newDay(start + idx);
          let overlap = false;
          if (dateMonth !== month) {
            overlap = true;
            newDate.setMonth(month);
          }
          newDate.clearTime();
          if (monthOverlap) {
            // Week overlaps with next month
            if (start > end && WEEK_DAYS - end - idx < 1) overlap = true;

            // Week overlaps with previous month
            if (start + idx < 1) overlap = true;
          }
          if (!overlap) {
            if ((0, _ark.isValidDate)(minDate) && newDate < minDate || (0, _ark.isValidDate)(maxDate) && newDate > maxDate) {
              overlap = true;
            }
          }
          const selected = (0, _ark.isValidDate)(dateSelected) && (0, _ark.dateOnly)(newDate).getTime() === (0, _ark.dateOnly)(dateSelected).getTime() && !overlap;
          return {
            date: newDate,
            overlap,
            selected
          };
        })
      };
    });
  }, [date, dateSelected, minDate, maxDate]);
  const select = _react.default.useCallback((date, event) => {
    if (!(0, _ark.isFunction)(onSelect)) return;
    if ((0, _ark.isValidDate)(minDate) && date < minDate) return;
    if ((0, _ark.isValidDate)(maxDate) && date > maxDate) return;
    onSelect(date, event);
  }, [onSelect, minDate, maxDate]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendarBody"
  }, _CalendarBodyHeader || (_CalendarBodyHeader = /*#__PURE__*/_react.default.createElement(_CalendarBodyHeader2.default, null)), weeks.map((week, idx) => /*#__PURE__*/_react.default.createElement(_CalendarWeek.default, {
    key: idx,
    value: week,
    onSelect: select
  })));
};
process.env.NODE_ENV !== "production" ? CalendarBody.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired,
  dateSelected: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  onSelect: _propTypes.default.func
} : void 0;
CalendarBody.defaultProps = {
  dateSelected: undefined,
  minDate: undefined,
  maxDate: undefined,
  onSelect: undefined
};
var _default = exports.default = CalendarBody;